/* 🤖 this file was generated by svg-to-ts*/
export const icoGitMerge: {
  name: 'git-merge';
  data: string;
} = {
  name: 'git-merge',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 10c-1.3 0-2.4.84-2.82 2H14c-2.49 0-6.54-1.83-6.92-4.21A2.995 2.995 0 006 2C4.34 2 3 3.34 3 5c0 1.3.84 2.4 2 2.81v8.37C3.84 16.6 3 17.7 3 19c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V11c1 1.5 4 3 7 3h1.18A2.996 2.996 0 0021 13c0-1.66-1.34-3-3-3zM6 20c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM6 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" fill="#909090"/></svg>`
};
